import { render, staticRenderFns } from "./AccountConfirmEmailChange.vue?vue&type=template&id=1a2b8c92&"
import script from "./AccountConfirmEmailChange.vue?vue&type=script&lang=js&"
export * from "./AccountConfirmEmailChange.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports